module.exports = __webpack_public_path__ + "img/customer-a-096.d90fd5ac.png";